exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-stepper .v-stepper__header{box-shadow:none}.v-stepper .v-stepper__header .v-stepper__label{text-align:center}@media only screen and (max-width:960px){.v-stepper__header{flex-wrap:nowrap!important}.v-stepper__step{flex-basis:50px!important;padding-left:10px!important;padding-right:10px!important}}", ""]);
// Exports
exports.locals = {
	"primary": "#0c4c91",
	"primaryLight": "#19b0de",
	"secondary": "#f5812d",
	"secondaryBright": "#c60b4e",
	"neutralLight": "#d9d9d9",
	"neutralBright": "#fdfdfd",
	"brandGrey": "#888786",
	"success": "#095"
};